import { PaymentMethods } from "@/types/organizations";

export const paymentMethodsLabels = {
  [PaymentMethods.CASH]: "Efectivo",
  [PaymentMethods.CREDIT_CARD]: "Tarjeta crédito/débito",
  [PaymentMethods.BANK_TRANSFER]: "Transferencia a banco",
};
